import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import * as Icons from "lucide-react";
import { Leaf } from "lucide-react";

function toPascal(s) { return (s || "leaf").split("-").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(""); }

export default function Categories() {
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get("/categories").then((r) => setCats(r.data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 lg:px-8 py-8 lg:py-12">
      <span className="text-terracotta font-500 text-sm uppercase tracking-wider">Explore</span>
      <h1 className="font-heading text-4xl lg:text-5xl text-forest tracking-tight mt-1 mb-8">Shop by Category</h1>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-6">
        {cats.map((c) => {
          const Icon = Icons[toPascal(c.icon)] || Leaf;
          return (
            <Link key={c.id} to={`/shop?category=${c.id}`} data-testid={`cat-card-${c.id}`}
              className="group relative rounded-[28px] overflow-hidden aspect-[4/3] soft-shadow hover:soft-shadow-lg transition-shadow">
              <img src={c.image} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-forest/85 via-forest/20 to-transparent" />
              <div className="absolute bottom-0 left-0 p-5 text-cream">
                <Icon className="w-6 h-6 mb-2 text-mustard" />
                <h3 className="font-heading text-2xl leading-tight">{c.name}</h3>
                <p className="text-sm text-cream/80">{c.product_count} products</p>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
